// extracted by mini-css-extract-plugin
export default {"cardBody":"c-e_cX"};